import { GroupMemberRole } from '@group/domain';
import React, { useCallback, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

type Props = {
  defaultRole: GroupMemberRole;
  onChange(role: GroupMemberRole): void;
  disabled: boolean;
};

export const InvitationRoleSelect: React.FC<Props> = ({ defaultRole, disabled, onChange }: Props) => {
  const { t } = useTranslation();
  const getDescription = (role: GroupMemberRole) => {
    switch (role) {
      case 'admin':
        return t('group.invite.role.adminDesc');
      case 'member':
        return t('group.invite.role.memberDesc');
      case 'guest':
        return (
          <Trans
            i18nKey="group.invite.role.guestDesc"
            components={{
              helpLink: (
                <a
                  href="https://balus-help.levii.co.jp/hc/ja/articles/15468851519769#h_01JVNNDCF27NAYRM5NKF5HXNS6"
                  target="_blank"
                  rel="noreferrer"
                  className="text-blue-700 underline"
                />
              ),
            }}
          />
        );
    }
  };
  const [selectedRole, setSelectedRole] = useState<GroupMemberRole>(defaultRole);
  const handleChangeRole = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const role = GroupMemberRole.load(event.target.value);
      setSelectedRole(role);
      onChange(role);
    },
    [onChange]
  );

  return (
    <div className="flex flex-row space-x-4">
      {GroupMemberRole.allValues().map((role) => (
        <label className="cursor-pointer rounded border p-4" style={{ width: 'calc(100% / 3)' }} key={role}>
          <input
            type="radio"
            name="role"
            value={role}
            className="form-radio mx-1"
            onChange={handleChangeRole}
            checked={role === selectedRole}
            disabled={disabled}
          />
          {t(GroupMemberRole.getLocalStringKey(role))}
          <hr className="my-1" />
          <span className="text-sm">{getDescription(role)}</span>
        </label>
      ))}
    </div>
  );
};
